// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tabListContainer":"_2yHsZ","withMobileMenu":"_1lzdH","tabListMobileContainer":"_2HK3y"};